import { Component, OnInit } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatDialog } from '@angular/material/dialog'
import { ProfileService } from '../../../core/services/profile/profile.service'
import {
  ProfileModel,
  SearchProfileModel,
} from '../../../core/models/profile.model'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { ProfileCreateComponent } from '../../../features/profile/profile-create/profile-create.component'
import { trigger, transition, style, animate } from '@angular/animations'
import { AssignPermissionComponent } from '../../../features/permission/assign-permission/assign-permission.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { AuthService } from '../../../core/services/auth/auth.service'
import { ProfileEditComponent } from '../../../features/profile/profile-edit/profile-edit.component'
import { SearchContactTypeModel } from '../../../core/models/contact-type.model'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'

@Component({
  selector: 'profile',
  imports: [
    MatCard,
    MatInputModule,
    MatIcon,
    TableListComponent,
    PaginationComponent,
    ProfileCreateComponent,
    AssignPermissionComponent,
    MatProgressBar,
    FormSearchComponent,
    MatPaginatorModule,
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  providers: [ProfileService, AuthService],
  standalone: true,
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('300ms', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ProfileComponent implements OnInit {
  constructor(
    private profileService: ProfileService,
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  loading = true
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  assignPermission = false
  item: ProfileModel = new ProfileModel()
  searchForm: SearchProfileModel = new SearchProfileModel()
  inputSearch = ''
  columns: any[] = [
    { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'description',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'active',
      key: 'ativo',
      description: 'Ativo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, manager: true },
      description: 'Ações',
    },
  ]
  screen = 'perfil'

  ngOnInit() {
    this.checkColumnAction()
    this.getProfile()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('deletar'),
        manager: this.checkPermission('editar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchProfile()
    } else {
      this.getProfile()
    }
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchProfile()
    } else {
      this.getProfile()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          ativo: item.statusId == '1' ? 'Ativo' : 'Inativo',
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getProfile() {
    this.loading = true
    this.profileService.listPagedProfile(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: ResponseRequestModel) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchProfile() {
    this.searchForm = new SearchProfileModel()
    this.loading = true
    this.profileService
      .searchPagedProfile(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: ResponseRequestModel) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  backProfile() {
    this.item = new ProfileModel()
    this.assignPermission = false
  }

  editProfile(item: any) {
    const dialogRef = this.dialog.open(ProfileEditComponent, {
      minWidth: '700px',
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  editPermission(item: any) {
    this.item = item
    this.assignPermission = true
  }

  deleteProfile(item: any) {
  }
}
